(function () {
  'use strict';

  var apps = document.querySelectorAll('[data-rsi-wo-app]');

  apps.forEach(function (app) {
    var iframe = app.querySelector('[data-rsi-wo-app-iframe]');
    if (!iframe) return;

    function markLoaded() {
      app.classList.add('is-loaded');
    }

    iframe.addEventListener('load', markLoaded);

    // Safety net: if the load event never fires (e.g. blocked embed), stop
    // showing the spinner after a timeout so the fallback link stays usable.
    window.setTimeout(markLoaded, 8000);
  });
})();
